import { EpisodeListItemThumbnail } from './EpisodeListItem.style'
import { useMemo, useState } from 'react'

export interface IImageObj {
  d: string
  m: string
  alt_d: string
  alt_m: string
  lazy: string
}

export const ShortVideoItemThumbnailComp = ({
  imageObj,
  name,
  isClip,
}: {
  imageObj: IImageObj
  name: string
  isClip?: boolean
}) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [image, setImage] = useState({
    default: true,
    link: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
    error: false,
  })

  useMemo(() => {
    if (imageObj?.d) {
      setImage({
        error: false,
        default: false,
        link: imageObj.d,
      })
    }
  }, [imageObj])

  return (
    <EpisodeListItemThumbnail
      theme={{
        useDefault: image.default,
        loaded: imageLoaded,
        error: image.error,
        isClip: isClip,
      }}
    >
      {image.link && (
        <img
          loading='lazy'
          src={image.link}
          alt={imageObj.alt_d || name}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageLoaded(true)
            setImage({
              ...image,
              error: true,
              link: 'https://media3.reshet.tv/image/upload/v1709542182/ott/400x400_Logo_Clear_1.webp',
            })
          }}
        />
      )}
    </EpisodeListItemThumbnail>
  )
}
